import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import Cache from '@/utils/cache.js'
import store from './store'
import { installServiceThemeOverlays } from '@/utils/serviceThemeOverlays'
function getUuid() {
    if (typeof crypto === 'object' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    } else {
        // 回退到兼容实现
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
}

const uuid = getUuid();
Cache.set('uuid', uuid)
import theme from '@/directives/theme.js'

Vue.directive('theme', theme)
Vue.use(ElementUI)
installServiceThemeOverlays(Vue, store, router)

// 添加复制文本到剪贴板的方法
Vue.prototype.$copyText = function(text) {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(resolve).catch(reject)
    } else {
      // 降级方案
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        resolve()
      } catch (err) {
        reject(err)
      } finally {
        document.body.removeChild(textarea)
      }
    }
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
